import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { format, startOfMonth, set, isValid } from 'date-fns';

import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import SearchIcon from '@material-ui/icons/Search';
import PDFIcon from '@material-ui/icons/PictureAsPdf';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import InputAdornment from '@material-ui/core/InputAdornment';
import Typography from '@material-ui/core/Typography';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';

import SelectTable from '../../components/DataTable/SelectTable';
import { fetchEmployees } from '../../store/actions/employee';
import { requestTimeClockReport, newRequestTimeClockReport, requestListReport } from '../../store/actions/report';
import ContentHeader from '../../components/ContentHeader/ContentHeader';
import Input from '../../components/Input/Input';
import { fileDownload } from '../../shared/fileDownload';
import CircularProgress from '@material-ui/core/CircularProgress';
import axiosInstance from '../../config/axiosInstance';
import { Link } from 'react-router-dom';
import QuestionMarkIcon from '@mui/icons-material/QuestionMark';
import { Dialog, DialogTitle, DialogContent, DialogContentText } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import LoadingMirror from './LoadPointMirrorReport/LoadingMirror'
import { usageLog } from '../../store/actions/globalActions';
import { Warning, Error } from '@material-ui/icons';
import WarningIcon from '@mui/icons-material/Warning';
import DescriptionIcon from '@material-ui/icons/Description';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Lock from '@material-ui/icons/Lock';
import axios from 'axios';




const styles = theme => ({
  container: {
    padding: `0 ${theme.spacing(3)}px`,
  },
});

class TimeClockReport extends React.Component {
  state = {
    withExtraHours: true,
    startDate: '',
    endDate: '',
    selected: [],
    searchQuery: '',
    validaetPremium: JSON.parse(localStorage.getItem('privileges')).isExportAfd,
    loading: false,
    uuid: '',
    lisEmployees: [],
    name: '',
    numSelected: null,
    companyName: '',
    autoFix: false,
    pointPre: false,
    loadingMirror: false,
    loadingMirrorMessage: '',
    buttonLoadingMirrorMessage: false,
    warningPointPre: false,
    nightExtraHoursInThePDF: false,
    isToConsiderNightHoursCorrected: false,
    anchorEl: null,
    reportExcel: false,
    privileges: {}
  };

  componentWillMount() {
    this.setState({
      startDate: startOfMonth(new Date()),
      endDate: set(new Date(), { hours: 23, minutes: 59, seconds: 59 }),
    });
    this.getListEmployees();
    this.getPrivileges();
  }

  closeLoadingMirror = () => {
    this.setState({
      loadingMirror: false,
      loadingMirrorMessage: '',
      buttonLoadingMirrorMessage: false,
      autoFix: false,
      warningPointPre: false,
      nightExtraHoursInThePDF: false,
      withExtraHours: true,
      isToConsiderNightHoursCorrected: false,
      reportExcel: false
    })
  }

  getPrivileges = async () => {
    const companyData = JSON.parse(localStorage.getItem('companies')).find(name => name.companyName);
    const params = {
      companyId: companyData.companyId
    }
    const result = await axiosInstance.post('/company/getPrivilegesCompany', params)
    this.setState({ privileges: result.data })
  }

  getListEmployees = async () => {
    const result = await axiosInstance.get('/employee/list')
    this.setState({ lisEmployees: result.data })
  }


  handleRequestReport = () => {
    const companyData = JSON.parse(localStorage.getItem('companies')).find(name => name.companyName);

    usageLog("relatórios/espelho_de_ponto/espelho_velho", companyData.companyId, companyData.userId)
    const {
      startDate, endDate, selected, withExtraHours,
    } = this.state;

    const report = {
      start: format(startDate, 'yyyy/MM/dd HH:mm'),
      end: format(endDate, 'yyyy/MM/dd HH:mm'),
      employees: selected,
      showCosts: withExtraHours,
      holidayV2: true,
    };

    this.props.onRequestReport(report);
  };

  handleListRequestReport = () => {
    const {
      startDate, endDate, selected, withExtraHours,
    } = this.state;
    const companyData = JSON.parse(localStorage.getItem('companies')).find(name => name.companyName);

    const report = {
      companyId: companyData.companyId,
      employeeId: selected,
      startPeriod: format(startDate, 'yyyy/MM/dd HH:mm'),
      endPeriod: format(endDate, 'yyyy/MM/dd HH:mm')
    };

    this.props.onRequestListReport(report);
  };

  handleClick = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  newHandleRequestReport = (modelFile) => {
    const warning = localStorage.setItem('warningPre', true);
    this.setState({ loadingMirror: true })
    this.setState({ loading: true })

    if (modelFile == 'Excel') {
      this.setState({ reportExcel: true })
    }

    const {
      startDate, endDate, selected, autoFix, nightExtraHoursInThePDF, isToConsiderNightHoursCorrected, withExtraHours
    } = this.state;

    const report = {
      start: format(startDate, 'yyyy/MM/dd HH:mm'),
      end: format(endDate, 'yyyy/MM/dd HH:mm'),
      employees: selected
    };
    const jwt = require('jsonwebtoken');
    const decodedToken = jwt.decode(localStorage.token);
    this.setState({ numSelected: selected.length })
    const companyData = JSON.parse(localStorage.getItem('companies')).find(name => name.companyName);
    usageLog("relatórios/espelho_de_ponto/novo_espelho", companyData.companyId, companyData.userId)
    this.setState({ companyName: localStorage.getItem('socialName') })

    const requestOptions = {
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
        'Accept': '/',
      },
      body: JSON.stringify({
        startPeriod: report.start,
        endPeriod: report.end,
        employeesId: selected,
        companyId: decodedToken.companyId,
        autoFix: autoFix,
        nightExtraHoursInThePDF: nightExtraHoursInThePDF,
        doNotShowValues: withExtraHours ? false : true,
        isToConsiderNightHoursCorrected: isToConsiderNightHoursCorrected,
        reportExcel: modelFile == 'Excel' ? true : false
      })
    };
    fetch('https://puntuapi.eastus.cloudapp.azure.com/api/timesheet/timesheet-request', requestOptions)
      // fetch('http://10.0.0.188:3000/timesheet-request', requestOptions)
      .then((response) => response.json())
      .then((data) => {
        this.handleLaCasaSinPapel();
        this.setState({ loadingMirror: true })
        this.setState({ uuid: data.uuid })
        this.observerNewHandleRequestReport(data.uuid);
      })
    this.setState({ anchorEl: false })
  };

  handleLaCasaSinPapel = async () => {
    try {
      await axiosInstance.get('/timesheet/referred',
        {
          headers: {
            'Authorization': `Bearer ${localStorage.token}`
          }
        }
      )
    } catch (error) {
      console.log(error)
    }
  }

  handleRequestpdf = (uuid) => {
    const jwt = require('jsonwebtoken');
    const decodedToken = jwt.decode(localStorage.token);
    // let nameReport
    // if (this.state.numSelected > 1) {
    //   nameReport = `Relatório Espelho de Ponto - ${this.state.companyName}.pdf`
    // } else {
    //   nameReport = `Relatório Espelho de Ponto - ${this.state.name}.pdf`
    // }

    fetch(`https://puntuapi.eastus.cloudapp.azure.com/api/timesheet/${decodedToken.companyId}/${uuid}`)
      // fetch(`http://10.0.0.188:3000/timesheet/${decodedToken.companyId}/${uuid}`)
      .then((response) => {
        const contentType = response.headers.get('Content-Type');

        if (contentType === 'application/json; charset=utf-8') {
          response.json().then((data) => {
            if (data.stateMessage !== 'Infelizmente deu um erro, verifique os dados dos funcionários e tente novamente!') {
              this.setState({ loadingMirrorMessage: data.stateMessage });
              this.observerNewHandleRequestReport(this.state.uuid);
            } else if (data.stateMessage === 'Infelizmente deu um erro, verifique os dados dos funcionários e tente novamente!') {
              this.setState({ loadingMirrorMessage: data.stateMessage });
              setTimeout(() => {
                this.setState({ loadingMirror: false, loading: false });
              }, 4000);
            }
          });
        } else {
          response.blob().then((blob) => {
            if (blob.size > 100) {
              this.setState({ loading: false });
              let nameReport
              // Verifique o tipo de conteúdo para determinar se é PDF ou XLSX
              if (contentType === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
                if (this.state.numSelected > 1) {
                  nameReport = `Relatório Espelho de Ponto - ${this.state.companyName}.xlsx`
                } else {
                  nameReport = `Relatório Espelho de Ponto - ${this.state.name}.xlsx`
                }
              } else if (contentType === 'application/pdf') {
                if (this.state.numSelected > 1) {
                  nameReport = `Relatório Espelho de Ponto - ${this.state.companyName}.pdf`
                } else {
                  nameReport = `Relatório Espelho de Ponto - ${this.state.name}.pdf`
                }
              }

              // Crie o link de download
              var url = window.URL.createObjectURL(blob);
              var a = document.createElement('a');
              a.href = url;
              a.download = nameReport;
              document.body.appendChild(a);
              a.click();
              a.remove();
              this.setState({ buttonLoadingMirrorMessage: true });
              this.setState({ loadingMirrorMessage: 'Oba, Confira seu espelho de ponto nos downloads!' });
            }
          });
        }
      });

  };

  observerNewHandleRequestReport = (value) => {
    if (this.state.uuid == 'impresso') {
      this.setState({ loading: false })
    } else {
      this.setState({ loading: true })
      setTimeout(() => this.handleRequestpdf(value), 5000)
    }
  };

  handleInputChange = name => (event) => {
    if (event && event.target) {
      const value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
      this.setState({ [name]: value });
    } else {
      this.setState({ [name]: event });
    }
  };



  handlePoinrPre = () => {
    this.setState({ pointPre: true })
  }

  warningPointPre = () => {
    const warningPre = JSON.parse(localStorage.getItem('warningPre'))
    if (this.state.autoFix && warningPre == false) {
      this.setState({ warningPointPre: true })
    } else {
      this.newHandleRequestReport()
    }
  }

  closeWarningPointPre = () => {
    this.setState({ warningPointPre: false })
    const warning = localStorage.setItem('warningPre', true);
  }

  closeHandlePointPre = () => {
    this.setState({ pointPre: false })
  }

  handleSelectAll = (event, checked, searchSelect) => {

    const searchIndex = searchSelect.map(employee => employee.id);
    if (checked) {
      const newSelected = this.state.selected.slice();

      /* eslint-disable no-underscore-dangle */
      if (searchIndex) {
        if (this.state.selected.indexOf(searchIndex[0]) === -1) {
          this.state.lisEmployees.map(employee =>
          (searchIndex.indexOf(employee.id) > -1 &&
            newSelected.indexOf(employee.id) === -1 &&
            employee._workingDay !== null
            ? newSelected.push(employee.id)
            : null));
        } else {
          this.state.lisEmployees.map(employee =>
          (searchIndex.indexOf(employee.id) > -1 && employee._workingDay !== null
            ? newSelected.splice(newSelected.indexOf(employee.id), 1)
            : null));
        }
      }
      /* eslint-enable */
      const scheduleSelected = []
      newSelected.forEach(employeeId => {
        for (let employee of this.state.lisEmployees) {
          if (employeeId == employee.id) {
            const workday = employee._workingDay ? scheduleSelected.push(employeeId) : null
          }
        }
      })

      this.setState({ selected: scheduleSelected });
    } else if (searchIndex.length === this.state.lisEmployees.length) {
      this.setState({ selected: [] });
    } else {
      const newSelected = this.state.selected.slice();
      this.state.lisEmployees.map(employee =>
      (searchIndex.indexOf(employee.id) > -1 && employee._workingDay !== null
        ? newSelected.splice(newSelected.indexOf(employee.id), 1)
        : null));

      const scheduleSelected = []
      newSelected.forEach(employeeId => {
        for (let employee of this.state.lisEmployees) {
          if (employeeId == employee.id) {
            const workday = employee._workingDay ? scheduleSelected.push(employeeId) : null
          }
        }
      })

      this.setState({ selected: scheduleSelected });
    }
  };

  handleSelect = (event, id, name, numSelected) => {
    const { selected } = this.state;
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];
    this.setState({ name: name })


    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }

    this.setState({ selected: newSelected });
  };

  isSelected = id => this.state.selected.indexOf(id) !== -1;

  render() {
    const { classes, loading } = this.props;
    const {
      withExtraHours, startDate, endDate, selected, searchQuery, validaetPremium, lisEmployees, autoFix, pointPre, warningPointPre,nightExtraHoursInThePDF, isToConsiderNightHoursCorrected, anchorEl, privileges
    } = this.state;

    const columns = [
      { name: 'enrollment', label: 'Matrícula' },
      { name: 'name', label: 'Nome' },
      { name: '_office', label: 'Cargo' },
      { name: 'department', label: 'Departamento' },
      { name: '_workingDay', label: 'Escala' },
    ];

    const searchFields = ['enrollment', 'name', '_office', 'department', '_workingDay'];

    const userIdSuporte = JSON.parse(localStorage.getItem('companies'))[0].userId

    const userIdsSuporte = [33920, 2005, 35802, 58886, 63485, 75892, 77251];
    const suportSchudeleConfig = userIdsSuporte.includes(userIdSuporte);
    return (
      <React.Fragment>
        {!this.state.loadingMirror ?
          <Grid>
            <ContentHeader
              title="Relatório Espelho de Ponto"
              subtitle="Selecione o período e os funcionários para gerar o relatório de pontos"
            >
              <Grid style={{ display: 'flex' }}>
                {
                  privileges.reportExcel || suportSchudeleConfig ?
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={this.handleClick}
                        disabled={loading || !(isValid(startDate) && isValid(endDate) && selected.length)}
                        style={{ marginLeft: 20 }}
                      >
                        <DescriptionIcon />  Gerar Relatório
                      </Button>
                      {
                        privileges.oldReport || suportSchudeleConfig ?
                          <span onClick={this.handleRequestReport} style={{ marginLeft: '25%', transform: 'translateX(-12%)', whiteSpace: 'nowrap', fontSize: '10px', fontWeight: 'bold' }}>
                            <Link
                              to={this.handleRequestReport}
                              style={{ color: '#4851de', textDecoration: 'none' }}
                            >
                              Gerar relatório na versão anterior
                            </Link>
                          </span> : null
                      }
                    </div>
                    :
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={this.warningPointPre}
                        disabled={loading || !(isValid(startDate) && isValid(endDate) && selected.length)}
                        style={{ marginBottom: '10px' }}
                      >
                        <PDFIcon /> Gerar Relatório
                      </Button>
                      {
                        privileges.oldReport || suportSchudeleConfig ?
                          <span onClick={this.handleRequestReport} style={{ marginLeft: '20%', transform: 'translateX(-12%)', whiteSpace: 'nowrap', fontSize: '10px', fontWeight: 'bold' }}>
                            <Link
                              to={this.handleRequestReport}
                              style={{ color: '#4851de', textDecoration: 'none' }}
                            >
                              Gerar relatório na versão anterior
                            </Link>
                          </span> : null
                      }
                    </div>
                }
                <Menu
                  id="simple-menu"
                  anchorEl={anchorEl}
                  open={Boolean(anchorEl)}
                  onClose={this.handleClose}
                >
                  <MenuItem
                    style={{
                      minWidth: 120,
                      justifyContent: 'space-between'
                    }}
                    onClick={() => this.newHandleRequestReport('pdf')}
                  >
                    <PDFIcon />  <span style={{ marginRight: '9px' }}>Gerar Relatório em PDF</span>
                  </MenuItem>
                  <MenuItem
                    style={{
                      justifyContent: 'space-between'
                    }}
                    onClick={() => {
                      this.newHandleRequestReport('Excel')
                      this.setState({ reportExcel: true })
                    }}
                  >

                    <DescriptionIcon />
                    <span style={{ marginLeft: '10px' }}>Gerar Relatório em Excel</span>
                  </MenuItem>
                </Menu>
              </Grid>
            </ContentHeader>
            <Paper elevation={2}>
              <Grid
                container
                justify="space-between"
                alignItems="baseline"
                className={classes.container}
              >
                <Grid item xs={12} md={5}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={withExtraHours}
                        onChange={this.handleInputChange('withExtraHours')}
                        value="withExtraHours"
                        color="primary"
                      />
                    }
                    label="Incluir cálculo de Horas Extras e Banco de Horas"
                  />
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={autoFix}
                          onChange={this.handleInputChange('autoFix')}
                          value="autoFix"
                          color="primary"
                        />
                      }
                      label="Pré-assinalar pontos ausentes"
                      style={{ whiteSpace: 'nowrap' }}
                    />
                    {/* aviso pontos pré */}
                    <Link to={this.handlePoinrPre} style={{ textDecoration: 'none' }}>
                      <Typography variant="body1" style={{ display: 'flex', alignItems: 'center' }} onClick={this.handlePoinrPre}>
                        <Paper style={{
                          display: 'inline-flex',
                          borderRadius: '50%',
                          backgroundColor: '#4851de',
                          // padding: theme.spacing(1),
                        }}>
                          <QuestionMarkIcon
                            style={{ padding: '3px', color: '#fff' }}
                          />
                        </Paper>
                      </Typography>
                    </Link>
                  </div>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={nightExtraHoursInThePDF}
                        onChange={this.handleInputChange('nightExtraHoursInThePDF')}
                        value="nightExtraHoursInThePDF"
                        color="primary"
                      />
                    }
                    label="Inserir a coluna de horas extras noturnas no espelho"
                    style={{ whiteSpace: 'nowrap' }}
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={isToConsiderNightHoursCorrected}
                        onChange={this.handleInputChange('isToConsiderNightHoursCorrected')}
                        value="isToConsiderNightHoursCorrected"
                        color="primary"
                      />
                    }
                    label="Fazer conversão da hora noturna"
                    style={{ whiteSpace: 'nowrap' }}
                  />
                  {/* AVISO DE CONFIRMAÇÃO de ponto pré-assinalado */}
                  <Dialog
                    open={warningPointPre}
                    onClose={this.closeWarningPointPre}
                    PaperProps={{
                      style: {
                        borderRadius: '25px',
                        maxWidth: '630px', // Ajuste a largura máxima desejada aqui
                        width: '100%' // Defina para uma largura específica se necessário
                      },
                    }}
                  >
                    <DialogTitle style={{ textAlign: 'center', fontSize: '13px', display: 'flex', alignItems: 'center', marginTop: 30 }}>
                      <Typography variant="body1" style={{ color: '#4851de', display: 'flex', alignItems: 'center', fontSize: '20px', whiteSpace: 'nowrap', fontWeight: 'bold', marginLeft: '31px', marginRight: '10px' }}>
                        <WarningIcon style={{ color: '#ffce31' }}>
                        </WarningIcon>
                        <a style={{ color: 'black', transform: 'translateX(-335%)', fontSize: '15px' }}>!</a>
                        AVISO DE CONFIRMAÇÃO
                      </Typography>
                    </DialogTitle>
                    <DialogContentText style={{ marginLeft: 60, marginRight: 80, fontSize: '14px', color: 'black' }}>
                      <a style={{ whiteSpace: 'nowrap' }} >Ao utilizar a função 'Pré-assinalar pontos ausentes', os pontos não registrados</a><br />
                      serão inseridos automaticamente no espelho de ponto dos colaboradores selecionados nos dias do período solicitado.
                    </DialogContentText>
                    <DialogContentText style={{ marginLeft: 60, marginRight: 80, fontSize: '14px', color: 'black' }}>
                      <a style={{ whiteSpace: 'nowrap' }} >Em caso de falta que não tenha sido informada na plataforma pelo gestor,</a><br />
                      considere o seguinte:
                    </DialogContentText>
                    <DialogContentText style={{ marginLeft: 60, marginRight: 80, fontSize: '14px', color: 'black' }}>
                      • Você terá que excluir esses pontos posteriormente.<br />
                      <a style={{ whiteSpace: 'nowrap' }} >• Isso pode impactar relatórios de controle de presença e folha de pagamento.</a>
                    </DialogContentText>
                    <div style={{ marginLeft: 60 }}>
                      <Button
                        variant="contained"
                        color="primary"
                        style={{ backgroundColor: '#4851de', fontSize: '12px', padding: '8px 15px', minWidth: '40px', borderRadius: '25px' }}
                        onClick={this.newHandleRequestReport}
                      >
                        <a style={{ marginLeft: 15, marginRight: 15 }}> Entendi as informações acima e desejo continuar</a>
                      </Button>
                    </div>
                    <div style={{ marginLeft: 60, marginTop: 5, marginBottom: 50 }}>
                      <Button
                        variant="contained"
                        style={{
                          fontSize: '12px',
                          padding: '8px 15px',
                          minWidth: '40px',
                          borderRadius: '25px',
                          color: '#4851de', // Define o texto do botão como branco
                          backgroundColor: 'white', // Define a cor de fundo do botão como azul
                          border: '1px solid #4851de', // Adiciona bordas azuis ao botão                        
                        }}
                        onClick={this.closeWarningPointPre}
                      >
                        <a style={{ marginLeft: 15, marginRight: 15 }}> Cancelar e retornar</a>
                      </Button>
                    </div>
                  </Dialog>

                  <Dialog
                    open={pointPre}
                    onClose={this.closeHandlePointPre}
                    PaperProps={{
                      style: {
                        borderRadius: '30px',
                        color: 'white',
                        backgroundColor: '#4851de'
                      },
                    }}

                  >
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <DialogTitle style={{ textAlign: 'center', fontSize: '13px', display: 'flex', alignItems: 'center' }}>
                        <Typography variant="body1" style={{ textAlign: 'left', fontSize: '14px', whiteSpace: 'nowrap', fontWeight: 'bold', marginLeft: '10px', marginRight: '10px' }}>Pontos pré-assinalados</Typography>
                      </DialogTitle>
                      <div style={{ marginLeft: '15%' }}>
                        <Paper style={{
                          display: 'inline-flex',
                          borderRadius: '50%',
                          backgroundColor: '#fff',
                        }}>
                          <CloseIcon
                            style={{ padding: '3px', color: '#4851de' }}
                            onClick={this.closeHandlePointPre}
                          />
                        </Paper>
                      </div>
                    </div>
                    <DialogContent>
                      <Typography variant="body1" style={{ textAlign: 'left', fontSize: '12px', fontWeight: 'bold', marginLeft: '10px', marginRight: '10px' }}>
                        Funcionalidade desenvolvida para<br /> simplificar e otimizar o trabalho do gestor.<br />
                        Quando um funcionário esquece de bater<br /> o ponto, a plataforma automaticamente<br />
                        insere os registros ausentes, garantindo<br /> a precisão e integridade dos relatórios.
                      </Typography>
                    </DialogContent>
                    <br />
                  </Dialog>

                  <TextField
                    value={searchQuery}
                    onChange={this.handleInputChange('searchQuery')}
                    label=" "
                    placeholder="Buscar"
                    type="text"
                    fullWidth
                    margin="normal"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon color="disabled" />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={6} container justify="space-around">
                  <Input
                    elementType="dateTimePicker"
                    label="Início do período"
                    margin="normal"
                    value={startDate}
                    onChange={this.handleInputChange('startDate')}
                  />
                  <Input
                    elementType="dateTimePicker"
                    minDate={startDate}
                    label="Fim do período"
                    margin="normal"
                    value={endDate}
                    onChange={this.handleInputChange('endDate')}
                  />
                </Grid>
              </Grid>

              <SelectTable
                rows={lisEmployees}
                columns={columns}
                loading={loading}
                disableRow="_workingDay"
                searchFields={searchFields}
                onSelect={this.handleSelect}
                onSelectAll={this.handleSelectAll}
                onSearchSelect={this.handleSearchSelect}
                checkSelect={this.isSelected}
                numSelected={selected.length}
                searchQuery={searchQuery.toUpperCase()}
                PointMirrorReport={validaetPremium ? false : true}
              />
            </Paper>

            <Typography color="textSecondary" style={{ marginTop: '10px' }}>
              *Não é possível gerar relatório de funcionários sem escala cadastrada
            </Typography>
          </Grid>
          :
          <LoadingMirror loadingMirrorMessage={this.state.loadingMirrorMessage} buttonLoadingMirrorMessage={this.state.buttonLoadingMirrorMessage} closeLoadingMirror={this.closeLoadingMirror} />
        }
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  loading: state.general.loading,
  // employees: state.employee.employees,
});

const mapDispatchToProps = dispatch => ({
  // onFetchEmployees: () => dispatch(fetchEmployees()),
  onRequestReport: report => dispatch(requestTimeClockReport(report)),
  onRequestListReport: report => dispatch(requestListReport(report))
});

TimeClockReport.propTypes = {
  classes: PropTypes.object.isRequired,
  onFetchEmployees: PropTypes.func.isRequired,
  onRequestReport: PropTypes.func.isRequired,
  // employees: PropTypes.array.isRequired,
  loading: PropTypes.bool,
};

TimeClockReport.defaultProps = {
  loading: false,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles)(TimeClockReport));
